import React from 'react';
import { Show, TabbedShowLayout, Tab,TextInput,SelectInput, Datagrid, EditButton, TextField, ReferenceField, ReferenceManyField, DateField, TopToolbar, RefreshButton, ListButton } from 'react-admin';

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const ShowActions = ({ basePath, data }) => (
    <TopToolbar>
        <RefreshButton />
        <ListButton basePath={basePath} />
        <EditButton basePath={basePath} record={data} />
    </TopToolbar>
)

const ShowTitle = ({ record }) => {
    return record && <span>Sales Officer Edit {record.name}</span>;
};

const SalesOfficersShow = ({ permissions, ...props }) => {
    return (
        <Show  actions={<ShowActions permissions={permissions} />} {...props} title={<ShowTitle />}>
              <TextInput label="Sales Officer Name" source="name" />
                    <TextInput label="Sales Officer Email" source="email" />
                    <TextInput label="Sales Officer Phone" source="phone" />
                 <SelectInput source="status" choices={[
                        { id: true, name: 'True' },
                        { id: false, name: 'False' },
                    ]}
                    defaultValue="status"
                />
        </Show>
    );
};

export default SalesOfficersShow;